/*!
 * levam-support-window v0.0.1
 * (c) Mikhail Tsirulnikov
 * Released under the UNLICENSED License.
 */
'use strict';

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script$2 = {
  props: {
    dense: {
      type: Boolean,
      "default": false
    },
    borderRadius: {
      type: String,
      "default": "10px"
    },
    label: {
      type: String,
      "default": ""
    },
    type: {
      type: String,
      "default": "input"
    },
    value: {
      type: String,
      "default": null
    },
    errorText: {
      type: String,
      "default": null
    }
  },
  data: function data() {
    return {};
  },
  mounted: function mounted() {
    this.applyCSS();
  },
  methods: {
    applyCSS: function applyCSS() {
      var cssRule = "\n      .LevamSupportWindowInput > input, .LevamSupportWindowInput > textarea { border-radius: ".concat(this.borderRadius, " }\n      .LevamSupportWindowInput > input + span::before,\n      .LevamSupportWindowInput > textarea + span::before { border-top-left-radius: ").concat(this.borderRadius, " }\n\n      .LevamSupportWindowInput > input + span::after,\n      .LevamSupportWindowInput > textarea + span::after {\n        border-top-right-radius: ").concat(this.borderRadius, ";\n      }\n      .LevamSupportWindowInput > input + span::before, .LevamSupportWindowInput > textarea + span::before{\n         border-top-left-radius: ").concat(this.borderRadius, ";\n      }\n      .LevamSupportWindowInput > input + span::before, .LevamSupportWindowInput > input + span::after, .LevamSupportWindowInput > textarea + span::before, .LevamSupportWindowInput > textarea + span::after{\n              height: ").concat(this.borderRadius, ";\n      }\n      ");
      var style = document.createElement("style");
      style.type = "text/css"; //append the style node as child of current component

      this.$el.appendChild(style);
      style.innerHTML = cssRule;
    }
  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier
/* server only */
, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
  if (typeof shadowMode !== 'boolean') {
    createInjectorSSR = createInjector;
    createInjector = shadowMode;
    shadowMode = false;
  } // Vue.extend constructor export interop.


  var options = typeof script === 'function' ? script.options : script; // render functions

  if (template && template.render) {
    options.render = template.render;
    options.staticRenderFns = template.staticRenderFns;
    options._compiled = true; // functional template

    if (isFunctionalTemplate) {
      options.functional = true;
    }
  } // scopedId


  if (scopeId) {
    options._scopeId = scopeId;
  }

  var hook;

  if (moduleIdentifier) {
    // server build
    hook = function hook(context) {
      // 2.3 injection
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
      // 2.2 with runInNewContext: true

      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__;
      } // inject component styles


      if (style) {
        style.call(this, createInjectorSSR(context));
      } // register component module identifier for async chunk inference


      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    }; // used by ssr in case component is cached and beforeCreate
    // never gets called


    options._ssrRegister = hook;
  } else if (style) {
    hook = shadowMode ? function () {
      style.call(this, createInjectorShadow(this.$root.$options.shadowRoot));
    } : function (context) {
      style.call(this, createInjector(context));
    };
  }

  if (hook) {
    if (options.functional) {
      // register for functional component in vue file
      var originalRender = options.render;

      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }

  return script;
}

var normalizeComponent_1 = normalizeComponent;

var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());
function createInjector(context) {
  return function (id, style) {
    return addStyle(id, style);
  };
}
var HEAD = document.head || document.getElementsByTagName('head')[0];
var styles = {};

function addStyle(id, css) {
  var group = isOldIE ? css.media || 'default' : id;
  var style = styles[group] || (styles[group] = {
    ids: new Set(),
    styles: []
  });

  if (!style.ids.has(id)) {
    style.ids.add(id);
    var code = css.source;

    if (css.map) {
      // https://developer.chrome.com/devtools/docs/javascript-debugging
      // this makes source maps inside style tags work properly in Chrome
      code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'; // http://stackoverflow.com/a/26603875

      code += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) + ' */';
    }

    if (!style.element) {
      style.element = document.createElement('style');
      style.element.type = 'text/css';
      if (css.media) style.element.setAttribute('media', css.media);
      HEAD.appendChild(style.element);
    }

    if ('styleSheet' in style.element) {
      style.styles.push(code);
      style.element.styleSheet.cssText = style.styles.filter(Boolean).join('\n');
    } else {
      var index = style.ids.size - 1;
      var textNode = document.createTextNode(code);
      var nodes = style.element.childNodes;
      if (nodes[index]) style.element.removeChild(nodes[index]);
      if (nodes.length) style.element.insertBefore(textNode, nodes[index]);else style.element.appendChild(textNode);
    }
  }
}

var browser = createInjector;

/* script */
var __vue_script__$2 = script$2; // For security concerns, we use only base name in production mode. See https://github.com/vuejs/rollup-plugin-vue/issues/258

script$2.__file = "LevamSupportWindowInput.vue";
/* template */

var __vue_render__$2 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('label', {
    staticClass: "LevamSupportWindowInput"
  }, [_vm.type === 'input' ? _c('input', {
    "class": {
      dense: _vm.dense
    },
    style: {
      borderRadius: _vm.borderRadius
    },
    attrs: {
      "placeholder": " "
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": function input($event) {
        return _vm.$emit('input', $event.target.value);
      },
      "keydown": function keydown($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
          return null;
        }

        return _vm.$emit('enter');
      }
    }
  }) : _vm._e(), _vm._v(" "), _vm.type === 'textarea' ? _c('textarea', {
    "class": {
      dense: _vm.dense
    },
    style: {
      borderRadius: _vm.borderRadius
    },
    attrs: {
      "placeholder": " "
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": function input($event) {
        return _vm.$emit('input', $event.target.value);
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "smooth"
    }
  }, [_vm.label ? _c('span', [_vm._v(_vm._s(_vm.label))]) : _vm._e()]), _vm._v(" "), _c('i', {
    staticClass: "lsw-error"
  }, [_vm._v(_vm._s(_vm.errorText))])], 1);
};

var __vue_staticRenderFns__$2 = [];
/* style */

var __vue_inject_styles__$2 = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-e68dccb4_0", {
    source: ".LevamSupportWindowInput i.lsw-error{color:#ff5252;font-size:.8em;font-style:normal}.LevamSupportWindowInput{width:100%;--pure-material-safari-helper1:rgb(\n      var(--pure-material-primary-rgb, 79, 131, 209)\n  );position:relative;display:inline-block;padding-top:6px;line-height:1.5;overflow:hidden}.LevamSupportWindowInput>input,.LevamSupportWindowInput>textarea{box-sizing:border-box;margin:0;border:solid 1px;border-color:rgba(var(--pure-material-onsurface-rgb,79,131,209),.5);border-top-color:transparent;border-radius:4px;padding:15px 13px 15px;width:100%;height:inherit;color:#000;background-color:transparent;box-shadow:none;font-family:inherit;font-size:inherit;line-height:inherit;caret-color:#000;transition:border .2s,box-shadow .2s}.LevamSupportWindowInput>input.dense,.LevamSupportWindowInput>textarea.dense{padding:6px 13px 6px}.LevamSupportWindowInput>input+span,.LevamSupportWindowInput>textarea+span{position:absolute;top:0;left:0;display:flex;border-color:rgba(var(--pure-material-onsurface-rgb,79,131,209),.6);width:100%;max-height:100%;color:rgba(var(--pure-material-onsurface-rgb,0,0,0),.6);font-size:75%;line-height:15px;cursor:text;transition:color .2s,font-size .2s,line-height .2s}.LevamSupportWindowInput>input+span::after,.LevamSupportWindowInput>input+span::before,.LevamSupportWindowInput>textarea+span::after,.LevamSupportWindowInput>textarea+span::before{content:\"\";display:block;box-sizing:border-box;margin-top:6px;border-top:solid 1px;border-top-color:rgba(var(--pure-material-onsurface-rgb,79,131,209),.6);min-width:10px;height:8px;pointer-events:none;box-shadow:inset 0 1px transparent;transition:border-color .2s,box-shadow .2s}.LevamSupportWindowInput>input+span::before,.LevamSupportWindowInput>textarea+span::before{margin-right:4px;border-left:solid 1px transparent;border-radius:4px 0}.LevamSupportWindowInput>input+span::after,.LevamSupportWindowInput>textarea+span::after{flex-grow:1;margin-left:4px;border-right:solid 1px transparent;border-radius:0 4px}.LevamSupportWindowInput:hover>input,.LevamSupportWindowInput:hover>textarea{border-color:rgba(var(--pure-material-onsurface-rgb,79,131,209),.87);border-top-color:transparent}.LevamSupportWindowInput:hover>input+span::after,.LevamSupportWindowInput:hover>input+span::before,.LevamSupportWindowInput:hover>textarea+span::after,.LevamSupportWindowInput:hover>textarea+span::before{border-top-color:rgba(var(--pure-material-onsurface-rgb,79,131,209),.87)}.LevamSupportWindowInput:hover>input:not(:focus):placeholder-shown,.LevamSupportWindowInput:hover>textarea:not(:focus):placeholder-shown{border-color:rgba(var(--pure-material-onsurface-rgb,79,131,209),.87)}.LevamSupportWindowInput>input:not(:focus):placeholder-shown,.LevamSupportWindowInput>textarea:not(:focus):placeholder-shown{border-top-color:rgba(var(--pure-material-onsurface-rgb,79,131,209),.6)}.LevamSupportWindowInput>input:not(:focus):placeholder-shown+span,.LevamSupportWindowInput>textarea:not(:focus):placeholder-shown+span{font-size:inherit;line-height:68px}.LevamSupportWindowInput>input.dense:not(:focus):placeholder-shown+span,.LevamSupportWindowInput>textarea.dense:not(:focus):placeholder-shown+span{font-size:inherit;line-height:50px}.LevamSupportWindowInput>input:not(:focus):placeholder-shown+span::after,.LevamSupportWindowInput>input:not(:focus):placeholder-shown+span::before,.LevamSupportWindowInput>textarea:not(:focus):placeholder-shown+span::after,.LevamSupportWindowInput>textarea:not(:focus):placeholder-shown+span::before{border-top-color:transparent}.LevamSupportWindowInput>input:focus,.LevamSupportWindowInput>textarea:focus{border-color:rgb(var(--pure-material-primary-rgb,79,131,209));border-top-color:transparent;box-shadow:inset 1px 0 var(--pure-material-safari-helper1),inset -1px 0 var(--pure-material-safari-helper1),inset 0 -1px var(--pure-material-safari-helper1);outline:0}.LevamSupportWindowInput>input:focus+span,.LevamSupportWindowInput>textarea:focus+span{color:rgb(var(--pure-material-primary-rgb,79,131,209))}.LevamSupportWindowInput>input:focus+span::after,.LevamSupportWindowInput>input:focus+span::before,.LevamSupportWindowInput>textarea:focus+span::after,.LevamSupportWindowInput>textarea:focus+span::before{border-top-color:var(--pure-material-safari-helper1)!important;box-shadow:inset 0 1px var(--pure-material-safari-helper1)}.LevamSupportWindowInput>input:disabled,.LevamSupportWindowInput>input:disabled+span,.LevamSupportWindowInput>textarea:disabled,.LevamSupportWindowInput>textarea:disabled+span{border-color:rgba(var(--pure-material-onsurface-rgb,79,131,209),.38)!important;border-top-color:transparent!important;color:rgba(var(--pure-material-onsurface-rgb,79,131,209),.38);pointer-events:none}.LevamSupportWindowInput>input:disabled+span::after,.LevamSupportWindowInput>input:disabled+span::before,.LevamSupportWindowInput>textarea:disabled+span::after,.LevamSupportWindowInput>textarea:disabled+span::before{border-top-color:rgba(var(--pure-material-onsurface-rgb,79,131,209),.38)!important}.LevamSupportWindowInput>input:disabled:placeholder-shown,.LevamSupportWindowInput>input:disabled:placeholder-shown+span,.LevamSupportWindowInput>textarea:disabled:placeholder-shown,.LevamSupportWindowInput>textarea:disabled:placeholder-shown+span{border-top-color:rgba(var(--pure-material-onsurface-rgb,79,131,209),.38)!important}.LevamSupportWindowInput>input:disabled:placeholder-shown+span::after,.LevamSupportWindowInput>input:disabled:placeholder-shown+span::before,.LevamSupportWindowInput>textarea:disabled:placeholder-shown+span::after,.LevamSupportWindowInput>textarea:disabled:placeholder-shown+span::before{border-top-color:transparent!important}@media not all and (min-resolution:0.001dpcm){@supports (-webkit-appearance:none){.LevamSupportWindowInput>input,.LevamSupportWindowInput>input+span,.LevamSupportWindowInput>input+span::after,.LevamSupportWindowInput>input+span::before,.LevamSupportWindowInput>textarea,.LevamSupportWindowInput>textarea+span,.LevamSupportWindowInput>textarea+span::after,.LevamSupportWindowInput>textarea+span::before{transition-duration:.1s}}}.LevamSupportWindowInput.theme--dark>input,.LevamSupportWindowInput.theme--dark>textarea{color:#fff;caret-color:#fff;border-left-color:#767676;border-right-color:#767676;border-bottom-color:#767676}.LevamSupportWindowInput.theme--dark>input+span,.LevamSupportWindowInput.theme--dark>textarea+span{color:#767676}.LevamSupportWindowInput.theme--dark>input:not(:focus):placeholder-shown,.LevamSupportWindowInput.theme--dark>textarea:not(:focus):placeholder-shown{border-top-color:#767676}.LevamSupportWindowInput.theme--dark>input:hover:not(:focus):placeholder-shown,.LevamSupportWindowInput.theme--dark>textarea:hover:not(:focus):placeholder-shown{border-top-color:rgb(var(--pure-material-primary-rgb,79,131,209))}.LevamSupportWindowInput.theme--dark>input:hover:not(:focus):placeholder-shown,.LevamSupportWindowInput.theme--dark>textarea:hover:not(:focus):placeholder-shown{border-top-color:#4f83d1}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__$2 = undefined;
/* module identifier */

var __vue_module_identifier__$2 = undefined;
/* functional template */

var __vue_is_functional_template__$2 = false;
/* style inject SSR */

var LevamSupportWindowInput = normalizeComponent_1({
  render: __vue_render__$2,
  staticRenderFns: __vue_staticRenderFns__$2
}, __vue_inject_styles__$2, __vue_script__$2, __vue_scope_id__$2, __vue_is_functional_template__$2, __vue_module_identifier__$2, browser, undefined);

var fetchTickets = function fetchTickets(url) {
  var trailingSlash = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return fetch("".concat(url, "/supporttickets") + (trailingSlash ? '/' : ''), {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json"
    },
    credentials: "include"
  }).then(function (r) {
    return r.json();
  });
};
var addTicket = function addTicket(url, data) {
  var trailingSlash = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var formData = new FormData(); // Добавляем обычные поля

  formData.append('message', data.message);
  formData.append('subject', data.subject); // Добавляем файлы, если они есть

  if (data.files && data.files.length > 0) {
    data.files.forEach(function (file) {
      formData.append("files[]", file); // Используем массив для файлов
    });
  }

  return fetch("".concat(url, "/supporttickets") + (trailingSlash ? '/' : ''), {
    method: "POST",
    headers: {
      Accept: "application/json" // "Content-Type" не указываем, так как fetch автоматически установит его для FormData

    },
    credentials: "include",
    body: formData // Используем FormData для отправки

  }).then(function (r) {
    return r.json();
  })["catch"](function (error) {
    console.error('Error:', error);
  });
};
var addMessage = function addMessage(url, ticketId, message) {
  var trailingSlash = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  return fetch("".concat(url, "/supporttickets/").concat(ticketId, "/add_message") + (trailingSlash ? '/' : ''), {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json"
    },
    credentials: "include",
    body: JSON.stringify({
      message: message,
      ticketId: ticketId
    })
  }).then(function (r) {
    return r.json();
  });
};

var translation = {
  en: {
    support_requests: "Support requests",
    new_appeal: "New appeal",
    subject: "Subject",
    describe_your_problem: "Please describe your problem",
    answering_requests: "Answering requests",
    supports_answer: "Support's answer",
    you_wrote: "You wrote",
    add_message: "Add message",
    field_is_required: "Field is required",
    successful_created_ticket: "A new request has been successfully sent to the technical support service, the answer to it will be posted here",
    status_new: "New",
    status_closed: "Closed",
    status_in_the_work: "In work",
    send: "Send",
    attach_file: "Attach image"
  },
  ru: {
    support_requests: "Запросы в техподдержку",
    new_appeal: "Новый",
    subject: "Тема обращения",
    describe_your_problem: "Пожалуйста, опишите вашу проблему",
    answering_requests: "Ответы на запросы",
    supports_answer: "Ответ поддержки",
    you_wrote: "Вы написали",
    add_message: "Добавить сообщение",
    field_is_required: "Это обязательное поле",
    successful_created_ticket: "Новый запрос успешно отправлен в службу технической поддержки, ответ на него будет размещен здесь",
    status_new: "Новая заявка",
    status_closed: "Закрытая заявка",
    status_in_the_work: "В работе",
    send: "Отправить",
    attach_file: "Прикрепить изображение"
  },
  ua: {
    support_requests: "Запити в техпідтримку",
    new_appeal: "Нове заявка",
    subject: "Тема звернення",
    describe_your_problem: "Будь ласка, опишіть вашу проблему",
    answering_requests: "Відповіді на запити",
    supports_answer: "Відповідь підтримки",
    you_wrote: "Ви написали",
    add_message: "Додати повідомлення",
    field_is_required: "Це обов'язкове поле",
    status_new: "Нова заявка",
    status_closed: "Закрита заявка",
    status_in_the_work: "В роботі",
    send: "Надіслати",
    attach_file: "Прикріпити зображення"
  },
  es: {
    support_requests: "Solicitudes de soporte técnico",
    new_appeal: "Nuevo",
    subject: "Asunto del mensaje",
    describe_your_problem: "Por favor describe tu problema",
    answering_requests: "Respondiendo Solicitudes",
    supports_answer: "Respuesta de soporte",
    you_wrote: "Tú escribiste",
    add_message: "Agregar mensaje",
    field_is_required: "Este campo es obligatorio",
    successful_created_ticket: "Se ha enviado con éxito una nueva solicitud al soporte técnico, la respuesta se publicará aquí",
    status_new: "Nueva solicitud",
    status_closed: "Pedido cerrado",
    status_in_the_work: "En progreso",
    send: "Enviar",
    attach_file: "Adjuntar una imagen"
  },
  de: {
    support_requests: "Support-Anfragen",
    new_appeal: "Neue Anfrage",
    subject: "Betreff",
    describe_your_problem: "Bitte beschreiben Sie Ihr Problem",
    answering_requests: "Anfragen beantworten",
    supports_answer: "Antwort des Supports",
    you_wrote: "Sie schrieben",
    add_message: "Nachricht hinzufügen",
    field_is_required: "Feld ist erforderlich",
    successful_created_ticket: "Eine neue Anfrage wurde erfolgreich an den technischen Support gesendet, die Antwort darauf wird hier veröffentlicht",
    status_new: "Neu",
    status_closed: "Geschlossen",
    status_in_the_work: "In Bearbeitung",
    send: "Senden",
    attach_file: "Bild anhängen"
  },
  pl: {
    support_requests: "Zgłoszenia wsparcia",
    new_appeal: "Nowe zgłoszenie",
    subject: "Temat",
    describe_your_problem: "Proszę opisać swój problem",
    answering_requests: "Odpowiadanie na zgłoszenia",
    supports_answer: "Odpowiedź wsparcia",
    you_wrote: "Napisałeś",
    add_message: "Dodaj wiadomość",
    field_is_required: "Pole jest wymagane",
    successful_created_ticket: "Nowe zgłoszenie zostało pomyślnie wysłane do serwisu wsparcia technicznego, odpowiedź na nie będzie tutaj opublikowana",
    status_new: "Nowe",
    status_closed: "Zamknięte",
    status_in_the_work: "W trakcie realizacji",
    send: "Wyślij",
    attach_file: "Dołącz obraz"
  }
};
var i18n = function i18n(lang, text) {
  if (translation[lang] && translation[lang][text]) {
    return translation[lang][text];
  }

  if (translation['en'] && translation['en'][text]) {
    return translation['en'][text];
  }

  return text;
};

//

function _empty$1() {}

function _awaitIgnored$1(value, direct) {
  if (!direct) {
    return value && value.then ? value.then(_empty$1) : Promise.resolve();
  }
}

var script$1 = {
  components: {
    LevamSupportWindowInput: LevamSupportWindowInput
  },
  props: {
    isDarkTheme: {
      type: Boolean,
      "default": false
    },
    bage: {
      type: String,
      "default": null
    },
    borderRadius: {
      type: String,
      "default": "10px"
    },
    tickets: {
      type: Array,
      "default": null
    },
    lang: {
      type: String,
      "default": "ru"
    },
    ticketId: {
      type: Number,
      "default": null
    },
    backendURL: {
      type: String,
      "default": "/"
    },
    trailingSlash: {
      type: Boolean,
      "default": false
    }
  },
  data: function data() {
    return {
      active: null,
      newMessage: null,
      supportImagesUrl: 'https://supporttickets.levam.net/users_uploaded_files/'
    };
  },
  mounted: function mounted() {
    this.active = this.ticketId;
    this.applyCSS();
  },
  watch: {
    active: function active() {
      this.newMessage = null;
    },
    tickets: function tickets() {
      var _this = this;

      this.$nextTick(function () {
        if (_this.ticketId) {
          document.getElementById("lsw_ticket_id_" + _this.ticketId).scrollIntoView();
        }
      });
    }
  },
  methods: {
    formatDate: function formatDate(dateStr) {
      var date = new Date(dateStr);
      var locale = this.lang !== "en" ? "ru-RU" : "en-US";
      var options = {
        year: "numeric",
        month: "long",
        day: "numeric"
      };
      return date.toLocaleDateString(locale, options) + " " + date.toLocaleTimeString(locale, {
        timeStyle: 'short'
      });
    },
    __: function __(text) {
      return i18n(this.lang, text);
    },
    addMessageToTicket: function addMessageToTicket(ticketId) {
      try {
        var _this3 = this;

        return _awaitIgnored$1(addMessage(_this3.backendURL, ticketId, _this3.newMessage, _this3.trailingSlash).then(function (result) {
          if (result.status === "success") {
            _this3.newMessage = null;

            _this3.$emit("onAddMessage", result.data);
          }
        }));
      } catch (e) {
        return Promise.reject(e);
      }
    },
    applyCSS: function applyCSS() {
      var cssRule = "\n      .lsw-exp-panels > *:last-child {\n        border-bottom-left-radius: ".concat(this.borderRadius, ";\n        border-bottom-right-radius: ").concat(this.borderRadius, ";\n        margin-bottom:0;\n      }\n      .lsw-exp-panels > *:first-child {\n        border-top-left-radius: ").concat(this.borderRadius, ";\n        border-top-right-radius: ").concat(this.borderRadius, ";\n        margin-top:0;\n      }\n      .lsw-exp-panels .lsw-exp-panel.active {\n        border-top-left-radius: ").concat(this.borderRadius, ";\n        border-top-right-radius: ").concat(this.borderRadius, ";\n        border-bottom-left-radius: ").concat(this.borderRadius, ";\n        border-bottom-right-radius: ").concat(this.borderRadius, ";\n      }\n      ");
      var style = document.createElement("style");
      style.type = "text/css"; //append the style node as child of current component

      this.$el.appendChild(style);
      style.innerHTML = cssRule;
    }
  }
};

/* script */
var __vue_script__$1 = script$1; // For security concerns, we use only base name in production mode. See https://github.com/vuejs/rollup-plugin-vue/issues/258

script$1.__file = "LevamSupportWindowExpansion.vue";
/* template */

var __vue_render__$1 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "lsw-wrap"
  }, [_vm.bage ? _c('div', {
    staticClass: "lsw-bage"
  }, [_vm._v("\n    " + _vm._s(_vm.bage) + "\n  ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "lsw-exp-panels"
  }, _vm._l(_vm.tickets, function (ticket) {
    return _c('div', {
      key: ticket.id,
      staticClass: "lsw-exp-panel",
      "class": {
        active: _vm.active === ticket.id
      }
    }, [_c('div', {
      staticClass: "lsw-exp-panel-header",
      on: {
        "click": function click($event) {
          _vm.active = _vm.active === ticket.id ? null : ticket.id;
        }
      }
    }, [_c('div', [_c('span', {
      staticClass: "caption",
      attrs: {
        "title": ticket.id,
        "id": 'lsw_ticket_id_' + ticket.id
      }
    }, [_vm._v(_vm._s(_vm.formatDate(ticket.created_at)))]), _vm._v(" "), _c('br'), _vm._v("\n        " + _vm._s(ticket.subject) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "spacer"
    }), _vm._v(" "), _c('div', {
      staticClass: "lsw-status",
      "class": ticket.status
    }, [_vm._v(_vm._s(_vm.__('status_' + ticket.status)))])]), _vm._v(" "), _c('hr', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: _vm.active === ticket.id,
        expression: "active === ticket.id"
      }]
    }), _vm._v(" "), _c('transition', {
      attrs: {
        "name": "smooth"
      }
    }, [_vm.active === ticket.id ? _c('div', {
      staticClass: "lsw-exp-panel-content"
    }, [_c('div', {
      staticClass: "images"
    }, _vm._l(ticket.images, function (image) {
      return _c('div', {
        key: image.id
      }, [_c('span', {
        staticClass: "caption"
      }, [_c('svg', {
        attrs: {
          "height": "16px",
          "width": "16px",
          "version": "1.1",
          "id": "Layer_1",
          "xmlns": "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "viewBox": "0 0 280.067 280.067",
          "xml:space": "preserve"
        },
        on: {
          "click": function click($event) {
            return _vm.$refs['uploadFile'].click();
          }
        }
      }, [_c('g', [_c('path', {
        staticStyle: {
          "fill": "#3273ba"
        },
        attrs: {
          "d": "M149.823,257.142c-31.398,30.698-81.882,30.576-113.105-0.429\n                          c-31.214-30.987-31.337-81.129-0.42-112.308l-0.026-0.018L149.841,31.615l14.203-14.098c23.522-23.356,61.65-23.356,85.172,0\n                          s23.522,61.221,0,84.586l-125.19,123.02l-0.044-0.035c-15.428,14.771-40.018,14.666-55.262-0.394\n                          c-15.244-15.069-15.34-39.361-0.394-54.588l-0.044-0.053l13.94-13.756l69.701-68.843l13.931,13.774l-83.632,82.599\n                          c-7.701,7.596-7.701,19.926,0,27.53s20.188,7.604,27.88,0L235.02,87.987l-0.035-0.026l0.473-0.403\n                          c15.682-15.568,15.682-40.823,0-56.39s-41.094-15.568-56.776,0l-0.42,0.473l-0.026-0.018l-14.194,14.089L50.466,158.485\n                          c-23.522,23.356-23.522,61.221,0,84.577s61.659,23.356,85.163,0l99.375-98.675l14.194-14.089l14.194,14.089l-14.194,14.098\n                          l-99.357,98.675C149.841,257.159,149.823,257.142,149.823,257.142z"
        }
      })])]), _vm._v(" "), _c('a', {
        attrs: {
          "target": "_blank",
          "href": _vm.supportImagesUrl + image.filename
        }
      }, [_vm._v(_vm._s(image.original_name))])])]);
    }), 0), _vm._v(" "), _vm._l(ticket.messages, function (message) {
      return _c('div', {
        key: message.id
      }, [_c('div', {
        staticClass: "message",
        "class": {
          user: message.author_type === 'user',
          support: message.author_type === 'support'
        }
      }, [_c('span', {
        staticClass: "caption"
      }, [_vm._v(_vm._s(_vm.formatDate(ticket.created_at))), _c('br'), _vm._v(" "), message.author_type == 'user' ? _c('span', [_vm._v(_vm._s(_vm.__("you_wrote")))]) : _c('span', [_vm._v(_vm._s(_vm.__("supports_answer")))]), _vm._v(":\n              ")]), _vm._v(" "), _c('br'), _vm._v("\n              " + _vm._s(message.message) + "\n            ")])]);
    }), _vm._v(" "), _c('div', {
      staticClass: "lsw-exp-panel-content-form"
    }, [_c('levam-support-window-input', {
      "class": {
        'theme--dark': _vm.isDarkTheme
      },
      attrs: {
        "dense": true,
        "type": "input",
        "label": _vm.__('add_message')
      },
      on: {
        "enter": function enter($event) {
          return _vm.addMessageToTicket(ticket.id);
        }
      },
      model: {
        value: _vm.newMessage,
        callback: function callback($$v) {
          _vm.newMessage = $$v;
        },
        expression: "newMessage"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "navigate icon",
      "class": {
        'theme--dark': _vm.isDarkTheme
      },
      on: {
        "click": function click($event) {
          return _vm.addMessageToTicket(ticket.id);
        }
      }
    }, [_c('i')])], 1)], 2) : _vm._e()])], 1);
  }), 0)]);
};

var __vue_staticRenderFns__$1 = [];
/* style */

var __vue_inject_styles__$1 = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-67f5864f_0", {
    source: ".lsw-wrap{max-height:70vh;overflow-y:auto}.lsw-wrap .lsw-exp-panels{padding:25px}.lsw-exp-panel-content{padding:0 20px 20px 20px;flex-direction:column}.lsw-exp-panel-content .message.user{margin-left:20px}.lsw-exp-panel-content .message.support{margin-right:20px}.lsw-exp-panel-content .message{-webkit-box-shadow:0 2px 1px -1px rgb(0 0 0 / 20%),0 1px 1px 0 rgb(0 0 0 / 14%),0 1px 3px 0 rgb(0 0 0 / 12%)!important;box-shadow:0 2px 1px -1px rgb(0 0 0 / 20%),0 1px 1px 0 rgb(0 0 0 / 14%),0 1px 3px 0 rgb(0 0 0 / 12%)!important;border-radius:6px;margin-top:5px;margin-bottom:5px;padding:10px}.lsw-exp-panel-content .lsw-exp-panel-content-form{display:flex;align-items:center}.lsw-exp-panel.active{margin-top:20px;margin-bottom:20px}.lsw-exp-panels:first-child.active{margin-top:0}.lsw-exp-panel-header{line-height:1;z-index:1;outline:0;padding:16px 24px;position:relative;cursor:pointer;display:flex}.lsw-exp-panels .images>div{display:flex;flex-direction:row;align-content:center}.lsw-exp-panels .images div .caption svg{width:16px;margin:0;display:inline}.lsw-exp-panels .images div .caption a{padding-left:5px;text-decoration:none;cursor:pointer;font-size:14px;border-bottom:none;color:#3273ba;display:inline!important}.lsw-exp-panels .images{padding-left:20px;padding-top:10px;z-index:10;position:relative}.lsw-exp-panels hr{-webkit-text-size-adjust:100%;word-break:normal;tab-size:4;text-rendering:optimizeLegibility;-webkit-font-smoothing:antialiased;-webkit-box-direction:normal;overflow-wrap:break-word;white-space:normal;font-size:.875rem;font-weight:400;line-height:1.375rem;letter-spacing:.0071428571em;list-style-type:none;cursor:auto;color:rgba(0,0,0,.87);background-repeat:no-repeat;box-sizing:inherit;padding:0;margin:0;overflow:visible;display:block;-webkit-box-flex:1;flex:1 1 0px;max-width:100%;height:0;max-height:0;border:solid;border-width:thin 0 0 0;transition:inherit;border-color:rgba(0,0,0,.12)}.lsw-exp-panels .lsw-exp-panel{position:relative}.lsw-exp-panels .lsw-exp-panel::before{border-radius:inherit;bottom:0;content:\"\";left:0;position:absolute;right:0;top:0;z-index:0;-webkit-transition:-webkit-box-shadow 280ms cubic-bezier(.4,0,.2,1);transition:-webkit-box-shadow 280ms cubic-bezier(.4,0,.2,1);transition:box-shadow 280ms cubic-bezier(.4,0,.2,1);will-change:box-shadow;-webkit-box-shadow:0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12);box-shadow:0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12)}.lsw-exp-panels .caption{font-size:.75rem!important;font-weight:400;letter-spacing:.0333333333em!important;line-height:1.25rem}.lsw-exp-panels .navigate.icon:hover{opacity:.7}.lsw-exp-panels .navigate.icon{color:#3273ba;cursor:pointer;margin-left:16px;margin-right:4px;margin-top:4px;width:14px;height:18px;-webkit-transform:rotate(90deg);transform:rotate(90deg)}.lsw-exp-panels .navigate.icon:before{content:\"\";position:absolute;left:0;top:-17px;width:0;height:0;border-top:solid 18px transparent;border-bottom:solid 18px currentColor;border-left:solid 7px transparent;border-right:solid 7px transparent}.lsw-exp-panels .navigate.icon.theme--dark:after{color:#1e1e1e}.lsw-exp-panels .navigate.icon:after{content:\"\";position:absolute;left:0;top:9px;width:0;height:0;color:#fff;border-top:solid 5px transparent;border-bottom:solid 5px currentColor;border-left:solid 7px transparent;border-right:solid 7px transparent}.lsw-exp-panels .navigate.icon.theme--dark:after{color:#1e1e1e}.lsw-exp-panels .navigate.icon i{position:absolute;width:10px;height:14px;left:2px;top:3px}.lsw-exp-panels .navigate.icon i:before{content:\"\";position:absolute;left:0;top:-14px;width:0;height:0;color:#fff;border-top:solid 14px transparent;border-bottom:solid 14px currentColor;border-left:solid 5px transparent;border-right:solid 5px transparent}.lsw-exp-panels .navigate.icon.theme--dark i:before{color:#1e1e1e}.lsw-exp-panels .navigate.icon i:after{content:\"\";position:absolute;left:0;top:6px;width:0;height:0;border-top:solid 4px transparent;border-bottom:solid 4px currentColor;border-left:solid 5px transparent;border-right:solid 5px transparent}.lsw-wrap .lsw-bage{display:block;padding:20px;color:#7dca31;border:1px solid #7dca31;margin:25px;margin-bottom:0}.lsw-status{display:flex;justify-content:flex-end;align-content:center;flex-wrap:wrap;color:#fff;padding:5px;font-size:.8em;border-radius:12px;padding-left:10px;padding-right:10px}.lsw-status.new{background:#7dca31}.lsw-status.closed{background:#d3dce3}.lsw-status.in_the_work{background:#e67e22}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__$1 = undefined;
/* module identifier */

var __vue_module_identifier__$1 = undefined;
/* functional template */

var __vue_is_functional_template__$1 = false;
/* style inject SSR */

var LevamSupportWindowExpansion = normalizeComponent_1({
  render: __vue_render__$1,
  staticRenderFns: __vue_staticRenderFns__$1
}, __vue_inject_styles__$1, __vue_script__$1, __vue_scope_id__$1, __vue_is_functional_template__$1, __vue_module_identifier__$1, browser, undefined);

//

function _await(value, then, direct) {
  if (direct) {
    return then ? then(value) : value;
  }

  if (!value || !value.then) {
    value = Promise.resolve(value);
  }

  return then ? value.then(then) : value;
}

function _empty() {}

function _awaitIgnored(value, direct) {
  if (!direct) {
    return value && value.then ? value.then(_empty) : Promise.resolve();
  }
}

var script = {
  components: {
    LevamSupportWindowExpansion: LevamSupportWindowExpansion,
    LevamSupportWindowInput: LevamSupportWindowInput
  },
  props: {
    borderRadius: {
      type: String,
      "default": "10px"
    },
    ticketId: {
      type: Number,
      //default: false,
      "default": null
    },
    isVisible: {
      type: Boolean,
      //default: false,
      "default": true
    },
    lang: {
      type: String,
      "default": "ru"
    },
    isDarkTheme: {
      type: Boolean,
      "default": false
    },
    trailingSlash: {
      type: Boolean,
      "default": false //default: true,

    },
    backendURL: {
      type: String,
      "default": "/" //default: "https://7zap.local:8443/api",

    }
  },
  data: function data() {
    return {
      isLoading: false,
      errors: {
        subject: null,
        message: null
      },
      tickets: [],
      currentTab: 1,
      bage: null,
      subject: null,
      message: null,
      files: []
    };
  },
  methods: {
    __: function __(text) {
      return i18n(this.lang, text);
    },
    addNewMesageToTicket: function addNewMesageToTicket(message) {
      this.errors.message = i18n(this.lang, "support_requests");
      this.tickets.find(function (ticket) {
        return ticket.id === message.ticket_id;
      }).messages.push(message);
    },
    getTickets: function getTickets() {
      var _this = this;

      fetchTickets(this.backendURL, this.trailingSlash).then(function (result) {
        if (result.status === "success") {
          _this.tickets = result.data;
        }
      });
    },
    remove: function remove(file) {
      try {
        var _this3 = this;

        _this3.files = _this3.files.filter(function (item) {
          return item.name !== file.name;
        });
        return _await();
      } catch (e) {
        return Promise.reject(e);
      }
    },
    upload: function upload() {
      try {
        var _this5 = this;

        var sizeInMB = (_this5.$refs.uploadFile.files[0].size / (1024 * 1024)).toFixed(2);

        if (sizeInMB > 2) {
          _this5.errors.message = 'File size more then 2 Mb!';
          return;
        }

        _this5.errors.message = '';

        _this5.files.push(_this5.$refs.uploadFile.files[0]);

        return _await();
      } catch (e) {
        return Promise.reject(e);
      }
    },
    addNewTicket: function addNewTicket() {
      try {
        var _this7 = this;

        if (_this7.isLoading) return;
        _this7.isLoading = true;
        _this7.bage = null;
        _this7.errors.message = _this7.message ? null : _this7.__("field_is_required");
        _this7.errors.subject = _this7.subject ? null : _this7.__("field_is_required");

        if (_this7.errors.message || _this7.errors.subject) {
          _this7.isLoading = false;
          return;
        }

        return _awaitIgnored(addTicket(_this7.backendURL, {
          message: _this7.message,
          subject: _this7.subject,
          files: _this7.files
        }, _this7.trailingSlash).then(function (result) {
          if (result.status === "success") {
            _this7.tickets.unshift(result.data);

            _this7.message = null;
            _this7.subject = null;
            _this7.currentTab = 2;
            _this7.bage = _this7.__("successful_created_ticket");
          } else {
            _this7.errors.message = result.message;
          }
        })["catch"](function (e) {
          _this7.errors.message = e.message;
        })["finally"](function () {
          _this7.isLoading = false;
        }));
      } catch (e) {
        return Promise.reject(e);
      }
    }
  },
  mounted: function mounted() {
    if (parseInt(this.ticketId) > 0) {
      this.currentTab = 2;
    }

    if (this.isVisible) {
      this.getTickets();
    }
  },
  watch: {
    isVisible: function isVisible(to) {
      if (to) {
        this.getTickets();
      } else {
        this.bage = null;
        this.message = null;
        this.subject = null;
        this.errors.message = null;
        this.errors.subject = null;
      }
    }
  }
};

/* script */
var __vue_script__ = script; // For security concerns, we use only base name in production mode. See https://github.com/vuejs/rollup-plugin-vue/issues/258

script.__file = "LevamSupportWindow.vue";
/* template */

var __vue_render__ = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('transition', {
    attrs: {
      "name": "smooth"
    }
  }, [_vm.isVisible ? _c('div', {
    staticClass: "LevamSupportWindow",
    "class": {
      'theme--dark': _vm.isDarkTheme
    }
  }, [_c('div', {
    staticClass: "overlay"
  }), _vm._v(" "), _c('div', {
    staticClass: "wrap"
  }, [_c('div', {
    staticClass: "lsw-content",
    style: {
      borderRadius: _vm.borderRadius
    }
  }, [_c('div', {
    staticClass: "lsw-title"
  }, [_c('div', {
    staticClass: "lsw-title-text"
  }, [_vm._v(_vm._s(_vm.__("support_requests")))]), _vm._v(" "), _c('div', {
    staticClass: "spacer"
  }), _vm._v(" "), _c('span', {
    staticClass: "lsw-close",
    on: {
      "click": function click($event) {
        return _vm.$emit('update:isVisible', false);
      }
    }
  }, [_c('span', {
    staticClass: "close"
  })])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "tabs"
  }, [_c('header', [_c('div', {
    staticClass: "material-tabs"
  }, [_c('a', {
    "class": {
      active: _vm.currentTab == 1
    },
    attrs: {
      "id": "tab1-tab",
      "borderRadius": _vm.borderRadius
    },
    on: {
      "click": function click($event) {
        _vm.currentTab = 1;
      }
    }
  }, [_vm._v(_vm._s(_vm.__("new_appeal")))]), _vm._v(" "), _c('a', {
    "class": {
      active: _vm.currentTab == 2
    },
    attrs: {
      "id": "tab2-tab",
      "borderRadius": _vm.borderRadius
    },
    on: {
      "click": function click($event) {
        _vm.currentTab = 2;
      }
    }
  }, [_vm._v(_vm._s(_vm.__("answering_requests")))]), _vm._v(" "), _c('span', {
    staticClass: "yellow-bar"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('transition', {
    attrs: {
      "name": "smooth"
    }
  }, [_c('div', {
    staticClass: "tab1",
    "class": {
      hide: _vm.currentTab == 2
    }
  }, [_c('levam-support-window-input', {
    staticClass: "lsw-input",
    "class": {
      'theme--dark': _vm.isDarkTheme
    },
    attrs: {
      "type": "input",
      "label": _vm.__('subject'),
      "error-text": _vm.errors.subject
    },
    model: {
      value: _vm.subject,
      callback: function callback($$v) {
        _vm.subject = $$v;
      },
      expression: "subject"
    }
  }), _vm._v(" "), _c('levam-support-window-input', {
    "class": {
      'theme--dark': _vm.isDarkTheme
    },
    attrs: {
      "type": "textarea",
      "label": _vm.__('describe_your_problem'),
      "error-text": _vm.errors.message
    },
    model: {
      value: _vm.message,
      callback: function callback($$v) {
        _vm.message = $$v;
      },
      expression: "message"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "spacer"
  }), _vm._v(" "), _c('div', {
    staticClass: "attachmentContainer"
  }, [_vm._l(_vm.files, function (file) {
    return _c('span', {
      key: file.name,
      staticClass: "list"
    }, [_c('span', {
      staticClass: "file"
    }, [_c('span', {
      staticClass: "remove",
      on: {
        "click": function click($event) {
          return _vm.remove(file);
        }
      }
    }, [_vm._v("✕")]), _vm._v(_vm._s(file.name))])]);
  }), _vm._v(" "), _c('div', {
    staticClass: "attach"
  }, [_c('svg', {
    attrs: {
      "height": "16px",
      "width": "16px",
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "viewBox": "0 0 280.067 280.067",
      "xml:space": "preserve"
    },
    on: {
      "click": function click($event) {
        return _vm.$refs['uploadFile'].click();
      }
    }
  }, [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#3273ba"
    },
    attrs: {
      "d": "M149.823,257.142c-31.398,30.698-81.882,30.576-113.105-0.429\n                        c-31.214-30.987-31.337-81.129-0.42-112.308l-0.026-0.018L149.841,31.615l14.203-14.098c23.522-23.356,61.65-23.356,85.172,0\n                        s23.522,61.221,0,84.586l-125.19,123.02l-0.044-0.035c-15.428,14.771-40.018,14.666-55.262-0.394\n                        c-15.244-15.069-15.34-39.361-0.394-54.588l-0.044-0.053l13.94-13.756l69.701-68.843l13.931,13.774l-83.632,82.599\n                        c-7.701,7.596-7.701,19.926,0,27.53s20.188,7.604,27.88,0L235.02,87.987l-0.035-0.026l0.473-0.403\n                        c15.682-15.568,15.682-40.823,0-56.39s-41.094-15.568-56.776,0l-0.42,0.473l-0.026-0.018l-14.194,14.089L50.466,158.485\n                        c-23.522,23.356-23.522,61.221,0,84.577s61.659,23.356,85.163,0l99.375-98.675l14.194-14.089l14.194,14.089l-14.194,14.098\n                        l-99.357,98.675C149.841,257.159,149.823,257.142,149.823,257.142z"
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "link",
    on: {
      "click": function click($event) {
        return _vm.$refs['uploadFile'].click();
      }
    }
  }, [_vm._v(_vm._s(_vm.__('attach_file')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: false,
      expression: "false"
    }],
    ref: 'uploadFile',
    attrs: {
      "type": "file",
      "accept": '.jpg,.png'
    },
    on: {
      "change": _vm.upload
    }
  })])], 2), _vm._v(" "), _c('div', {
    staticClass: "spacer"
  }), _vm._v(" "), _c('button', {
    staticClass: "lsw-button",
    "class": {
      loading: _vm.isLoading
    },
    on: {
      "click": _vm.addNewTicket
    }
  }, [_vm.isLoading ? _c('div', {
    staticClass: "lds-ring"
  }, [_c('div'), _c('div'), _c('div'), _c('div')]) : _vm._e(), _vm._v("\n                " + _vm._s(_vm.__('send')) + "\n              ")])], 1)]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "smooth"
    }
  }, [_c('div', {
    staticClass: "tab2",
    "class": {
      hide: _vm.currentTab == 1
    }
  }, [_c('levam-support-window-expansion', {
    attrs: {
      "bage": _vm.bage,
      "ticketId": _vm.ticketId,
      "lang": _vm.lang,
      "backendURL": _vm.backendURL,
      "tickets": _vm.tickets,
      "borderRadius": _vm.borderRadius,
      "isDarkTheme": _vm.isDarkTheme,
      "trailingSlash": _vm.trailingSlash
    },
    on: {
      "onAddMessage": function onAddMessage(data) {
        return _vm.addNewMesageToTicket(data);
      }
    }
  })], 1)])], 1)])])])]) : _vm._e()]);
};

var __vue_staticRenderFns__ = [];
/* style */

var __vue_inject_styles__ = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-ece7ef78_0", {
    source: ".LevamSupportWindow .lsw-input{margin-bottom:20px}.LevamSupportWindow hr{width:100%;-webkit-text-size-adjust:100%;word-break:normal;tab-size:4;font-size:16px;text-rendering:optimizeLegibility;-webkit-font-smoothing:antialiased;-webkit-tap-highlight-color:transparent;line-height:1.5;pointer-events:auto;overflow-wrap:break-word;white-space:normal;color:rgba(0,0,0,.87);-webkit-box-direction:normal;background-repeat:no-repeat;box-sizing:inherit;padding:0;margin:0;overflow:visible;display:block;-webkit-box-flex:1;flex:1 1 0px;max-width:100%;height:0;max-height:0;border:solid;border-width:thin 0 0 0;transition:inherit;border-color:rgba(0,0,0,.12)}.LevamSupportWindow.theme--dark .tabs .material-tabs{border-bottom-color:#000}.LevamSupportWindow.theme--dark .tabs .material-tabs>a.active{color:#3273ba}.LevamSupportWindow.theme--dark .tabs .material-tabs>a{color:#fff}.LevamSupportWindow .lsw-add-new-ticket{align-self:flex-end}.LevamSupportWindow .lsw-button{background:#7dca31;font-size:1em;padding:10px;display:flex;color:#fff;border:none;align-self:flex-end;border-radius:10px;cursor:pointer;margin-top:20px;align-items:center}.LevamSupportWindow .lsw-button.loading{background:#bdbdbd;cursor:inherit!important}.LevamSupportWindow .spacer{word-break:normal;tab-size:4;font-size:16px;text-rendering:optimizeLegibility;line-height:1.5;pointer-events:auto;overflow-wrap:break-word;white-space:normal;color:rgba(0,0,0,.87);background-repeat:no-repeat;box-sizing:inherit;padding:0;margin:0;-webkit-box-flex:1!important;flex-grow:1!important}.LevamSupportWindow.theme--dark .wrap .lsw-content{background:#1e1e1e;color:#fff}.LevamSupportWindow{font-family:var(\n      --pure-material-font,\n      \"Roboto\",\n      \"Segoe UI\",\n      BlinkMacSystemFont,\n      system-ui,\n      -apple-system\n  )}.LevamSupportWindow .wrap .lsw-content .lsw-title .lsw-close{display:flex;position:relative}.LevamSupportWindow .wrap .lsw-content .lsw-title{align-items:center;box-sizing:border-box;display:flex;flex-basis:auto;flex-grow:0;flex-shrink:0;flex-wrap:wrap;height:62px;padding:16px 24px 10px;font-size:1.25rem;margin:0;width:100%;white-space:nowrap;text-overflow:ellipsis;overflow:hidden}.LevamSupportWindow .wrap .lsw-content .lsw-title .lsw-title-text{white-space:nowrap;text-overflow:ellipsis;overflow:hidden}.LevamSupportWindow .wrap .lsw-content{width:80%;max-height:90%;max-width:700px;flex-wrap:wrap;background:#fff;display:flex;box-shadow:rgba(0,0,0,.2) 0 11px 15px -7px,rgba(0,0,0,.14) 0 24px 38px 3px,rgba(0,0,0,.12) 0 9px 46px 8px}.LevamSupportWindow .wrap{max-height:100%;display:flex;box-sizing:border-box;justify-content:center;align-items:center;height:100%;padding:0;width:100%;z-index:1001;position:fixed;top:0;left:0}.LevamSupportWindow .overlay{-webkit-box-align:center;-ms-flex-align:center;align-items:center;border-radius:inherit;display:-webkit-box;display:-ms-flexbox;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;position:fixed;top:0;left:0;right:0;bottom:0;pointer-events:none;-webkit-transition:.3s cubic-bezier(.25,.8,.5,1),z-index 1ms;transition:.3s cubic-bezier(.25,.8,.5,1),z-index 1ms;width:100%;height:100%;opacity:.46;background-color:#212121;border-color:#212121;z-index:1000}.LevamSupportWindow .close{opacity:1;cursor:pointer}.LevamSupportWindow .close:hover{opacity:.5}.LevamSupportWindow .close:after,.LevamSupportWindow .close:before{position:absolute;left:0;top:-20px;content:\" \";height:20px;width:4px;background-color:#3273ba}.LevamSupportWindow.theme--dark .close:after,.LevamSupportWindow.theme--dark .close:before{background-color:#fff}.LevamSupportWindow .close:before{transform:rotate(45deg)}.LevamSupportWindow .close:after{transform:rotate(-45deg)}.LevamSupportWindow .tabs{width:100%}.LevamSupportWindow .tabs header{position:relative}.LevamSupportWindow .tabs .tab1{display:flex;flex-direction:column;padding:25px}.LevamSupportWindow .tabs .tab1.hide,.LevamSupportWindow .tabs .tab2.hide{display:none}.LevamSupportWindow .tabs .material-tabs{position:relative;display:flex;padding:0;border-bottom:1px solid #e0e0e0}.LevamSupportWindow .tabs .material-tabs>a:before{background-color:currentColor;bottom:0;content:\"\";left:0;opacity:0;pointer-events:none;position:absolute;right:0;top:0;-webkit-transition:.3s cubic-bezier(.25,.8,.5,1);transition:.3s cubic-bezier(.25,.8,.5,1)}.LevamSupportWindow .tabs .material-tabs>a:hover::before{opacity:.04}.LevamSupportWindow .tabs .material-tabs>a{position:relative;display:inline-block;text-decoration:none;cursor:pointer;padding:22px 0 22px 0;color:#424f5a;text-align:center;width:50%;-webkit-transition:.3s cubic-bezier(.25,.8,.5,1);transition:.3s cubic-bezier(.25,.8,.5,1)}.LevamSupportWindow .tabs .material-tabs>a.active{outline:0}.LevamSupportWindow .tabs .material-tabs>a:not(.active):hover{background-color:inherit;color:#7c848a}.LevamSupportWindow.theme--dark .tabs .material-tabs>a:not(.active):hover{background-color:inherit;color:#fff}.LevamSupportWindow.theme--dark .tabs .material-tabs>a:hover::before{background-color:#3273ba;opacity:.3}@media only screen and (max-width:520px){.LevamSupportWindow .tabs .nav-tabs.material-tabs>li>a{font-size:11px}}.LevamSupportWindow .tabs .yellow-bar{position:absolute;z-index:10;bottom:0;height:3px;background:#3273ba;display:block;left:0;transition:left .2s ease;-webkit-transition:left .2s ease}.LevamSupportWindow .tabs #tab1-tab.active~span.yellow-bar{left:0;width:50%}.LevamSupportWindow .tabs #tab2-tab.active~span.yellow-bar{left:50%;width:50%}.smooth-enter-active,.smooth-leave-active{transition:height .1s;overflow:hidden}.smooth-enter,.smooth-leave-to{height:0}.LevamSupportWindow .lds-ring{color:#fff;margin-right:6px}.LevamSupportWindow .lds-ring,.LevamSupportWindow .lds-ring div{box-sizing:border-box}.LevamSupportWindow .lds-ring{display:inline-block;position:relative;width:14px;height:14px}.LevamSupportWindow .lds-ring div{box-sizing:border-box;display:block;position:absolute;width:14px;height:14px;margin:0;border:2px solid currentColor;border-radius:50%;animation:lds-ring 1.2s cubic-bezier(.5,0,.5,1) infinite;border-color:currentColor transparent transparent transparent}.LevamSupportWindow .lds-ring div:nth-child(1){animation-delay:-.45s}.LevamSupportWindow .lds-ring div:nth-child(2){animation-delay:-.3s}.LevamSupportWindow .lds-ring div:nth-child(3){animation-delay:-.15s}.LevamSupportWindow .attachmentContainer .list{display:flex;flex-direction:column;padding-left:10px}.LevamSupportWindow .attachmentContainer .list .file{font-size:.8em;display:flex;flex-direction:row}.LevamSupportWindow .attachmentContainer .list .remove{cursor:pointer;color:red;padding-right:3px;font-size:1.2em}.LevamSupportWindow .attachmentContainer .attach svg{width:16px;margin:0;margin-right:5px}.LevamSupportWindow .attachmentContainer .attach .link{cursor:pointer;font-size:14px;border-bottom:none;color:#3273ba}.LevamSupportWindow .attachmentContainer .attach{display:flex;flex-direction:row;color:#3273ba;margin-top:5px;width:100%;align-content:center;flex-wrap:wrap}@keyframes lds-ring{0%{transform:rotate(0)}100%{transform:rotate(360deg)}}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* style inject SSR */

var LevamSupportWindow = normalizeComponent_1({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, browser, undefined);

var index = {
  install: function install(Vue, options) {
    Vue.component("levam-support-window", LevamSupportWindow);
  }
};

module.exports = index;
